import { render, staticRenderFns } from "./candidateStatus.vue?vue&type=template&id=3fb6f996&scoped=true"
import script from "./candidateStatus.vue?vue&type=script&lang=js"
export * from "./candidateStatus.vue?vue&type=script&lang=js"
import style0 from "./candidateStatus.vue?vue&type=style&index=0&id=3fb6f996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb6f996",
  null
  
)

export default component.exports